exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".couponCodeForm[data-v-1dba2ae4]{padding:20px 20px 10px}", ""]);

// exports
